import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appFindSearch]',
})
export class FindSearchDirective {
  @HostListener('click')
  onClick() {
    if (window.getSelection) {
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
      }
    }
    document.execCommand('find');
  }
}





